import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, mergeProps as _mergeProps, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-left px-[16px] flex" }
const _hoisted_2 = { class: "station-form-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-full border-b-2 mb-4" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-full border-b-2 mb-4" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-full border-b-2 mb-4" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-full border-b-2 mb-4" }, null, -1)
const _hoisted_7 = {
  class: "station-form-category-container mb-4 text-left",
  "data-testid": "consult-bulk-sector-specialty"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "station-form-category-title" }, "Setor e especialidade (opcional)"),
  /*#__PURE__*/_createElementVNode("span", { class: "rounded-full bg-primary5 px-2 text-[10px] font-bold text-primary30" }, "NOVO")
], -1)
const _hoisted_9 = {
  key: 0,
  class: "mt-2 rounded bg-amber-50 px-3 py-2 text-sm text-amber-800",
  "data-testid": "consult-move-sector-warning"
}
const _hoisted_10 = {
  key: 1,
  class: "mt-2 rounded bg-amber-50 px-3 py-2 text-sm text-amber-800",
  "data-testid": "consult-move-specialty-warning"
}
const _hoisted_11 = {
  key: 2,
  class: "mt-2 rounded bg-primary5 px-3 py-2 text-sm text-gray-800",
  "data-testid": "consult-bulk-server-preview"
}
const _hoisted_12 = {
  key: 1,
  class: "flex flex-col gap-4 mt-4"
}
const _hoisted_13 = {
  key: 0,
  class: "text-left input w-full flex flex-col input mt-2 max-h-[420px] px-[8px] overflow-y-scroll"
}
const _hoisted_14 = { class: "mt-6 flex justify-between gap-5" }
const _hoisted_15 = { class: "flex flex-col" }
const _hoisted_16 = { class: "flex gap-5" }
const _hoisted_17 = { class: "flex gap-5" }
const _hoisted_18 = { class: "flex gap-7 mt-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Tipo de plantão", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Nossa equipe", -1)
const _hoisted_21 = { class: "flex gap-7 mt-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Pagamento á vista", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Antecipação Solicitada", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Antecipação Paga", -1)
const _hoisted_25 = { class: "flex gap-5 justify-end mt-4 px-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LocaleAndScheduleForm = _resolveComponent("LocaleAndScheduleForm")!
  const _component_PricesForm = _resolveComponent("PricesForm")!
  const _component_HourAndDateForm = _resolveComponent("HourAndDateForm")!
  const _component_StationDetailsForm = _resolveComponent("StationDetailsForm")!
  const _component_BulkSectorSpecialtyFields = _resolveComponent("BulkSectorSpecialtyFields")!
  const _component_ChangeReasonField = _resolveComponent("ChangeReasonField")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_PlaceholderDoctorBlockedModal = _resolveComponent("PlaceholderDoctorBlockedModal")!
  const _component_filled_button = _resolveComponent("filled-button")!
  const _component_modal_vue = _resolveComponent("modal-vue")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_modal_vue, {
    onClose: $setup.handleToggleModal,
    modalActive: $setup.modals[$setup.modalName],
    hasFooterBorder: true
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("strong", null, "Editando " + _toDisplayString($props.isSelectAll ? $props.totalRows : $props.ids?.length) + " plantões", 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_filled_button, {
          loading: $setup.formStates.isLoading,
          onClick: $setup.handleSubmit,
          text: "Salvar alterações",
          height: "52px",
          width: "180px"
        }, null, 8, ["loading", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_LocaleAndScheduleForm, {
          company: $setup.formStates.company,
          "onUpdate:company": _cache[0] || (_cache[0] = ($event: any) => (($setup.formStates.company) = $event)),
          "health-unit": $setup.formStates.healthUnit,
          "onUpdate:healthUnit": _cache[1] || (_cache[1] = ($event: any) => (($setup.formStates.healthUnit) = $event)),
          schedule: $setup.formStates.schedule,
          "onUpdate:schedule": _cache[2] || (_cache[2] = ($event: any) => (($setup.formStates.schedule) = $event)),
          doctor: $setup.formStates.doctor,
          "onUpdate:doctor": _cache[3] || (_cache[3] = ($event: any) => (($setup.formStates.doctor) = $event))
        }, null, 8, ["company", "health-unit", "schedule", "doctor"]),
        _hoisted_3,
        _createVNode(_component_PricesForm, {
          doctor: $setup.formStates.doctor,
          "onUpdate:doctor": _cache[4] || (_cache[4] = ($event: any) => (($setup.formStates.doctor) = $event)),
          value: $setup.formStates.value,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (($setup.formStates.value) = $event)),
          inCash: $setup.formStates.inCash,
          "onUpdate:inCash": _cache[6] || (_cache[6] = ($event: any) => (($setup.formStates.inCash) = $event)),
          advanceRequested: $setup.formStates.advanceRequested,
          "onUpdate:advanceRequested": _cache[7] || (_cache[7] = ($event: any) => (($setup.formStates.advanceRequested) = $event)),
          advancePaid: $setup.formStates.advancePaid,
          "onUpdate:advancePaid": _cache[8] || (_cache[8] = ($event: any) => (($setup.formStates.advancePaid) = $event)),
          "modified-value": $setup.formStates.modifiedValue,
          "onUpdate:modifiedValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.formStates.modifiedValue) = $event)),
          modifiedValueEnabled: true,
          company: $setup.formStates.company,
          urlConviteDoctor: $setup.formStates.infos.urlConviteDoctor
        }, null, 8, ["doctor", "value", "inCash", "advanceRequested", "advancePaid", "modified-value", "company", "urlConviteDoctor"]),
        _hoisted_4,
        _createVNode(_component_HourAndDateForm, {
          date: $setup.formStates.date,
          "onUpdate:date": _cache[10] || (_cache[10] = ($event: any) => (($setup.formStates.date) = $event)),
          timezone: $setup.formStates.timezone,
          "onUpdate:timezone": _cache[11] || (_cache[11] = ($event: any) => (($setup.formStates.timezone) = $event)),
          startHour: $setup.formStates.startHour,
          "onUpdate:startHour": _cache[12] || (_cache[12] = ($event: any) => (($setup.formStates.startHour) = $event)),
          endHour: $setup.formStates.endHour,
          "onUpdate:endHour": _cache[13] || (_cache[13] = ($event: any) => (($setup.formStates.endHour) = $event)),
          isUpdateMode: true,
          onValidationStatus: $setup.handleValidation
        }, null, 8, ["date", "timezone", "startHour", "endHour", "onValidationStatus"]),
        _hoisted_5,
        _createVNode(_component_StationDetailsForm, {
          "station-type": $setup.formStates.stationType,
          "onUpdate:stationType": _cache[14] || (_cache[14] = ($event: any) => (($setup.formStates.stationType) = $event)),
          "our-team": $setup.formStates.ourTeam,
          "onUpdate:ourTeam": _cache[15] || (_cache[15] = ($event: any) => (($setup.formStates.ourTeam) = $event))
        }, null, 8, ["station-type", "our-team"]),
        ($setup.isDashboardV2)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                ($setup.moveWarning)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString($setup.moveWarning), 1))
                  : _createCommentVNode("", true),
                ($setup.moveSpecialtyWarning)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString($setup.moveSpecialtyWarning), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_BulkSectorSpecialtyFields, {
                  class: "mt-3",
                  sector: $setup.bulkSector,
                  "onUpdate:sector": _cache[16] || (_cache[16] = ($event: any) => (($setup.bulkSector) = $event)),
                  specialty: $setup.bulkSpecialty,
                  "onUpdate:specialty": _cache[17] || (_cache[17] = ($event: any) => (($setup.bulkSpecialty) = $event)),
                  items: $setup.fieldItems,
                  "sector-locked-reason": $setup.sectorLockedReason,
                  "disabled-reason": $setup.bulkDisabledReason
                }, null, 8, ["sector", "specialty", "items", "sector-locked-reason", "disabled-reason"]),
                ($setup.serverPreview)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString($setup.serverPreview), 1))
                  : _createCommentVNode("", true)
              ])
            ], 64))
          : _createCommentVNode("", true),
        ($setup.reasonFields.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reasonFields, (field, index) => {
                return (_openBlock(), _createBlock(_component_ChangeReasonField, _mergeProps({
                  key: field.kind,
                  modelValue: $setup.reasonValues[field.kind],
                  "onUpdate:modelValue": ($event: any) => (($setup.reasonValues[field.kind]) = $event)
                }, field, {
                  "show-errors": $setup.showReasonErrors,
                  "scope-note": index === $setup.reasonFields.length - 1 ? $setup.reasonScopeNote : ''
                }), null, 16, ["modelValue", "onUpdate:modelValue", "show-errors", "scope-note"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_v_text_field, {
                modelValue: $setup.formStates.value,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.formStates.value) = $event)),
                class: "w-full",
                prefix: "R$",
                type: "number",
                label: "Valor acordado com o médico",
                color: "primary20",
                variant: "outlined",
                density: "comfortable"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createVNode(_component_v_text_field, {
                  modelValue: $setup.formStates.date,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.formStates.date) = $event)),
                  label: "Dia",
                  class: "w-full",
                  color: "primary20",
                  variant: "outlined",
                  error: $setup.formStates.hasErrorDate,
                  "error-messages": $setup.formStates.hasErrorDate ? 'Campo obrigatório' : '',
                  density: "comfortable"
                }, null, 8, ["modelValue", "error", "error-messages"]), [
                  [_directive_maska, '##/##/####']
                ]),
                _createVNode(_component_v_autocomplete, {
                  modelValue: $setup.formStates.timezone,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.formStates.timezone) = $event)),
                  class: "w-full",
                  color: "primary20",
                  label: "Fuso Horário",
                  theme: "light",
                  items: $setup.timezones,
                  variant: "outlined",
                  error: $setup.formStates.hasErrorDate,
                  "error-messages": $setup.formStates.hasErrorDate ? 'Campo obrigatório' : '',
                  density: "comfortable"
                }, {
                  item: _withCtx(({ props, item }) => [
                    _createVNode(_component_v_list_item, _mergeProps(props, {
                      title: item?.raw?.title,
                      subtitle: item?.raw?.subtitle
                    }), null, 16, ["title", "subtitle"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "items", "error", "error-messages"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createVNode(_component_v_text_field, {
                  modelValue: $setup.formStates.startHour,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.formStates.startHour) = $event)),
                  label: "Início",
                  class: "w-full",
                  color: "primary20",
                  variant: "outlined",
                  error: $setup.formStates.hasErrorDate,
                  "error-messages": $setup.formStates.hasErrorDate ? 'Campo obrigatório' : '',
                  density: "comfortable"
                }, null, 8, ["modelValue", "error", "error-messages"]), [
                  [_directive_maska, '##:##']
                ]),
                _withDirectives(_createVNode(_component_v_text_field, {
                  modelValue: $setup.formStates.endHour,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.formStates.endHour) = $event)),
                  label: "Fim",
                  class: "w-full",
                  color: "primary20",
                  variant: "outlined",
                  error: $setup.formStates.hasErrorDate,
                  "error-messages": $setup.formStates.hasErrorDate ? 'Campo obrigatório' : '',
                  density: "comfortable"
                }, null, 8, ["modelValue", "error", "error-messages"]), [
                  [_directive_maska, '##:##']
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", null, [
                _hoisted_19,
                _createVNode(_component_v_radio_group, {
                  density: "compact",
                  modelValue: $setup.formStates.stationType,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.formStates.stationType) = $event)),
                  column: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio, {
                      label: "Fixo",
                      color: "primary",
                      value: "FIXO"
                    }),
                    _createVNode(_component_v_radio, {
                      label: "Cobertura",
                      color: "primary",
                      value: "COBERTURA"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", null, [
                _hoisted_20,
                _createVNode(_component_v_radio_group, {
                  density: "compact",
                  modelValue: $setup.formStates.ourTeam,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.formStates.ourTeam) = $event)),
                  column: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio, {
                      label: "Sim",
                      color: "primary",
                      value: true
                    }),
                    _createVNode(_component_v_radio, {
                      label: "Não",
                      color: "primary",
                      value: false
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", null, [
                _hoisted_22,
                _createVNode(_component_v_radio_group, {
                  density: "compact",
                  modelValue: $setup.formStates.inCash,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.formStates.inCash) = $event)),
                  column: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio, {
                      label: "Sim",
                      color: "primary",
                      value: true
                    }),
                    _createVNode(_component_v_radio, {
                      label: "Não",
                      color: "primary",
                      value: false
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", null, [
                _hoisted_23,
                _createVNode(_component_v_radio_group, {
                  density: "compact",
                  modelValue: $setup.formStates.advanceRequested,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.formStates.advanceRequested) = $event)),
                  column: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio, {
                      label: "Sim",
                      color: "primary",
                      value: true
                    }),
                    _createVNode(_component_v_radio, {
                      label: "Não",
                      color: "primary",
                      value: false
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", null, [
                _hoisted_24,
                _createVNode(_component_v_radio_group, {
                  density: "compact",
                  modelValue: $setup.formStates.advancePaid,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.formStates.advancePaid) = $event)),
                  column: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_radio, {
                      label: "Sim",
                      color: "primary",
                      value: true
                    }),
                    _createVNode(_component_v_radio, {
                      label: "Não",
                      color: "primary",
                      value: false
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.placeholderBlocked.isOpen.value)
        ? (_openBlock(), _createBlock(_component_PlaceholderDoctorBlockedModal, {
            key: 1,
            modelValue: $setup.placeholderBlocked.isOpen.value,
            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.placeholderBlocked.isOpen.value) = $event)),
            "doctor-name": $setup.placeholderBlocked.doctorName.value,
            "allow-unidentified": false
          }, null, 8, ["modelValue", "doctor-name"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onClose", "modalActive"]))
}